import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Container, Form } from 'react-bootstrap';
import { Loader, SectionHeader, addStatusToast } from '../../common/components';
import { useAppDispatch } from '../../app/hooks';
import {
  GetSalesStatisticsResponse,
  getTravelAgencyReportAsync,
  StartDateFilter,
} from './statisticsSlice';

function TraveAgencyReport() {
  const dispatch = useAppDispatch();
  const createdFrom = useRef<HTMLInputElement>();
  const createdTo = useRef<HTMLInputElement>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    // declare the data fetching function
    const fetchData = async () => {};

    // call the function
    fetchData()
      // make sure to catch any error
      .catch(console.error);
  }, []);

  const loadStatistics = async () => {
    const filter = {} as StartDateFilter;

    if (createdFrom.current.value) {
      filter.startDate ??= {};
      filter.startDate.from = createdFrom.current.value;
      filter.startDate.to = createdTo.current.value;
    }

    dispatch(getTravelAgencyReportAsync(filter))
      .then(action => {
        setLoading(false);
        const response = action.payload as GetSalesStatisticsResponse;

        if (response.status === 200) {
          const link = document.createElement('a');
          link.href = response.blobUrl;
          link.setAttribute('download', response.fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } else if (response.status === 204) {
          dispatch(
            addStatusToast({
              Title: 'Virhe',
              IsFailed: true,
              Message: `Hakuehdoilla ei löytynyt varauksia`,
            }),
          );
        } else {
          dispatch(
            addStatusToast({
              Title: 'Virhe',
              IsFailed: true,
              Message: `Raportin lataus ei onnistunut`,
            }),
          );
        }
      })
      .catch(error => {
        setLoading(false);
        dispatch(
          addStatusToast({
            Title: 'Virhe',
            IsFailed: true,
            Message: `Raportin lataus ei onnistunut`,
          }),
        );
      });
  };

  return (
    <>
      <Helmet>
        <title>Matkatoimisto raportti</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Matkatoimisto raportti']}
          Title="Matkatoimisto raportti"
        />

        <div className="bg-white p-5 position-relative">
          <div className="row gx-48 gy-24">
            <div className="col-6">
              <Form.Label htmlFor="createdFrom" className="form-label">
                Varaus alkaa
              </Form.Label>
              <div className="d-flex align-items-center">
                <input
                  type="date"
                  id="createdFrom"
                  className="form-control"
                  ref={createdFrom}
                />
                <strong className="px-1">-</strong>
                <input
                  type="date"
                  id="createdTo"
                  className="form-control"
                  ref={createdTo}
                />
              </div>
            </div>
          </div>
          <div className="d-flex align-items-start gap-16">
            <button
              type="button"
              onClick={loadStatistics}
              className="btn btn-primary mt-32"
              disabled={loading}
            >
              <span>Lataa</span>
            </button>
            {loading && <Loader IsLoading />}
          </div>
        </div>
      </Container>
    </>
  );
}

export default TraveAgencyReport;
